import { apiClient } from "../App";

// Get All Landing Pages (extra me search jaisi query keys aati hain)
export const getLandingPages = (extra = {}) => {
  return apiClient.get("/landing-pages", { params: extra });
};

// Create Landing Page
export const createLandingPage = (data) => {
  return apiClient.post("/landing-pages/", data);
};

// Update Landing Page
export const updateLandingPage = (id, data) => {
  return apiClient.put(`/landing-pages/${id}`, data);
};

// Delete Landing Page
export const deleteLandingPage = (id) => {
  return apiClient.delete(`/landing-pages/${id}`);
};